// extracted by mini-css-extract-plugin
export default {"container":"Ul-z","title":"Vl-z","linkContainer":"Wl-z","viewItemLink":"Xl-z"};